

































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class QuantitySelection extends Vue {
  @Prop({ required: true })
  readonly selectedQuantity: number

  @Prop({ required: true })
  readonly maxSelectableQuantity: number

  /**
   * maxSelectableQuantityが0というのは購入不可を意味する
   * 購入不可のとき個数変更は+も-も不可とする
   */
  get isDisabled(): boolean {
    return this.maxSelectableQuantity === 0
  }

  get isDecrementDisabled(): boolean {
    return this.isDisabled || this.selectedQuantity <= 1
  }

  get isIncrementDisabled(): boolean {
    return this.isDisabled || this.selectedQuantity >= this.maxSelectableQuantity
  }

  get isValueDisabled(): boolean {
    return this.isDecrementDisabled && this.isIncrementDisabled
  }

  decrement(): void {
    if (this.isDecrementDisabled) {
      return
    }

    this.$emit('change', this.selectedQuantity - 1)
  }

  increment(): void {
    if (this.isIncrementDisabled) {
      return
    }

    this.$emit('change', this.selectedQuantity + 1)
  }
}
